import { TranslateUnauthenticatedPipe } from '../../filters/translate-unauthenticated.pipe';
import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { SiffiLanguagePickerComponent } from '../../components/siffi-language-picker/siffi-language-picker.component';
import Session from '../../utils/session.service';
import Config from '../../utils/config.service';
import AngularFilterHelperService from '../../services/angular-filter-helper.service';
import AngularRoutingHelperService from '../../services/angular-routing-helper.service';
import DictionaryService from '../../services/dictionary.service';
import AppLanguageService from '../../services/app-language.service';
import { Subscription } from 'rxjs';
import adapter from 'webrtc-adapter';

declare const AvTestController: any;

@Component({
	standalone: true,
	selector: 'av-test',
	templateUrl: './av-test.component.html',
	imports: [ CommonModule, TranslateUnauthenticatedPipe, FormsModule, SiffiLanguagePickerComponent ]
})
export default class AvTestView implements OnInit, OnDestroy {
	private session: Session = inject(Session);
	private config: Config = inject(Config);
	private angularFilterHelperService: AngularFilterHelperService = inject(AngularFilterHelperService);
	private angularRoutingHelperService: AngularRoutingHelperService = inject(AngularRoutingHelperService);
	private dictionaryService: DictionaryService = inject(DictionaryService);
	private appLanguageService: AppLanguageService = inject(AppLanguageService);
	
	vm: any = undefined;
	private titleSubscription: Subscription = undefined;
	
	constructor() {
		this.vm = this;
	}
	
	ngOnInit() {
		this.determineLocation();
		this.vm.user = this.session.getSession() && this.session.getSession().user || false;
		this.vm.locales = this.appLanguageService.getLanguagesByOrigin(this.vm.origin);
		this.vm.language = window.navigator.language;
		var localeFromQueryParam: any = this.angularRoutingHelperService.getQueryParam('locale');
		this.vm.locale = localeFromQueryParam || ((this.vm.user && this.vm.user.deviceLanguage) ? this.vm.user.deviceLanguage : null);
		if (!this.vm.locale) {
			this.vm.locale = window.sessionStorage.getItem("locale");
		}
		if (this.vm.locale) {
			window.sessionStorage.setItem("locale", this.vm.locale);
		}
		this.vm.lang = (this.vm.locale !== null && this.vm.locale !== 'null' ? this.vm.locale : 'et_EE');
		this.vm.logoSuffix = this.vm.lang.split("_")[0];
		this.vm.isAuthenticated = !!this.session.getSession();
		this.vm.adapterLoaded = false;
		this.vm.materializeLoaded = false;
		this.vm.avtestLoaded = false;
		this.vm.uaParserLoaded = false;
		this.vm.dictionaryLoaded = false;
		this.vm.allGood = false;
		
		this.vm.navigateToRoot = this.navigateToRoot;
		this.vm.reload = this.reload;
		this.vm.reloadToPrevisit = this.reloadToPrevisit;
		this.vm.goBack = this.goBack;
		this.vm.getLocaleOption = this.getLocaleOption;
		this.vm.toggleLangMenu = this.toggleLangMenu;
		this.vm.setLocale = this.setLocale;
		this.loadTranslations();
		this.loadComponents();
		
		this.titleSubscription = this.angularFilterHelperService.watchDocumentTitleUnauthenticated('Av_Test.Av_Test_Title');
	};

	ngOnDestroy() {
		if (this.titleSubscription) {
			this.titleSubscription.unsubscribe();
		}
	}
	
	determineLocation() {
		var host: any = window.location.hostname;
		if (host.includes("siffi")) {
			this.vm.origin= "siffi.com";
			this.vm.product = "SIFFI";
			this.vm.headerClass = "o-container c-container";
		} else if (host.includes("minudoc")) {
			this.vm.origin= "minudoc.ee";
			var url: any = window.location.href;
			this.vm.product = url.includes("eelvisiit") ? "PREVISIT" : "MINUDOC";
			this.vm.headerClass = "";
		}
	}
	
	navigateToRoot($event) {
		$event.preventDefault();
		if (this.vm.product === "PREVISIT") {
			window.history.back();
		} else {
			window.location.href = this.config.getPublicWebHomeUrl(this.vm.origin, this.vm.locale);
		}
	}
	
	loadComponents() {
		(window as any).adapter = adapter;
		this.vm.adapterLoaded = true;
		console.info('AV_TEST.TELEMETRY', {
			event: 'adapter.ready',
			data: adapter.browserDetails,
			timestamp: new Date().toISOString()
		});

		var parser: any = document.createElement("script");
		parser.src = "https://dqs3afosyxqoy.cloudfront.net/assets/common/js/av-test/ua-parser.min.js";
		parser.async = false;
		document.body.appendChild(parser);
		
		parser.onload = () => {
			this.vm.uaParserLoaded = true;
		};

		var materialize: any = document.createElement("script");
		materialize.src = "https://dqs3afosyxqoy.cloudfront.net/assets/common/js/av-test/materialize.min.js";
		materialize.async = true;
		document.body.appendChild(materialize);
		
		materialize.onload = () => {
			this.vm.materializeLoaded = true;
		};
		
		var avtest: any = document.createElement("script");
		avtest.src = "https://dqs3afosyxqoy.cloudfront.net/assets/common/js/av-test/AvTest.js";
		avtest.async = true;
		document.body.appendChild(avtest);
		
		avtest.onload = () => {
			this.vm.avtestLoaded = true;
		};
		
		this.checkLoadedStatus();
	}
	
	checkLoadedStatus()  {
		if (this.vm.adapterLoaded && this.vm.materializeLoaded && this.vm.avtestLoaded && this.vm.uaParserLoaded && this.vm.dictionaryLoaded && !this.vm.allGood) {
			new AvTestController("siffi.com", this.getAvTestTranslations());
			this.vm.allGood = true;
			var host: any = window.location.hostname;
			if (host.includes("siffi")) {
				this.vm.headerClass = "o-container c-container";
			} else if (host.includes("minudoc")) {
				this.vm.headerClass = "";
			}
			var main: any = document.getElementById("main");
			if (main) {
				main.className = main.className.replace("c-container","");
			}
		} else {
			setTimeout(() => {
				this.checkLoadedStatus();
			}, 100);
		}
	}

	private loadTranslations() {
		var locale: any = this.vm.locale;
		if (!locale || locale === 'null') {
			locale = 'en_GB';
		}

		this.dictionaryService.setLanguage(locale)
			.catch(() => {})
			.finally(() => {
				this.vm.dictionaryLoaded = true;
			});
	}
	
	reload(event) {
		if (event && event.preventDefault) {
			event.preventDefault();
		}
		this.angularRoutingHelperService.clearQueryParamsDirty();
		var sessionUser = this.session.getSession() ? this.session.getSession().user : null;
		if (this.vm.activePath === this.angularRoutingHelperService.goHomeAndReturnPath(sessionUser)) {
			this.angularRoutingHelperService.reloadRoute();
		} else {
			this.angularRoutingHelperService.goHomeAndKeepHistory(this.session.getSession() ? this.session.getSession().user : null);
		}
	}
	
	goBack($event) {
		if ($event && $event.preventDefault) {
			$event.preventDefault();
		}
		window.history.back();
	}
	
	reloadToPrevisit(event) {
		if (event && event.preventDefault) {
			event.preventDefault();
		}
		this.angularRoutingHelperService.clearQueryParamsDirty()
		this.angularRoutingHelperService.setPath('/pre-visit');
	}
	
	getLocaleOption(locale) {
		return this.appLanguageService.getLanguage(locale);
	}
	
	toggleLangMenu(toOpen) {
		if (typeof toOpen === 'undefined') {
			toOpen = !this.vm.langOpen;
		}
		this.vm.langOpen = toOpen;
	}
	
	setLocale(locale) {
		if (this.vm.langDisabled) return;
		this.vm.langDisabled = true;
		
		this.vm.locale = locale;
		window.sessionStorage.setItem("locale", locale);
		this.angularRoutingHelperService.clearQueryParamsDirty()
		this.angularRoutingHelperService.reloadRoute();
	}

	private getAvTestTranslations() {
		return {
			Start: this.translateAvTest('Av_Test.Start_Testing'),
			Stop: this.translateAvTest('Av_Test.Stop_Testing'),
			CameraPending: this.translateAvTest('Av_Test.Camera_Pending'),
			CameraOk: this.translateAvTest('Av_Test.Camera_Ok'),
			CameraFail: this.translateAvTest('Av_Test.Camera_Fail'),
			MicrophonePending: this.translateAvTest('Av_Test.Microphone_Pending'),
			MicrophoneOk: this.translateAvTest('Av_Test.Microphone_Ok'),
			MicrophoneFail: this.translateAvTest('Av_Test.Microphone_Fail'),
			PopupsPending: this.translateAvTest('Av_Test.Popups_Pending'),
			PopupsOk: this.translateAvTest('Av_Test.Popups_Ok'),
			PopupsFail: this.translateAvTest('Av_Test.Popups_Fail'),
			SignalPending: this.translateAvTest('Av_Test.Signal_Pending'),
			SignalOk: this.translateAvTest('Av_Test.Signal_Ok'),
			SignalFail: this.translateAvTest('Av_Test.Signal_Fail'),
			UdpPending: this.translateAvTest('Av_Test.Udp_Pending'),
			UdpOk: this.translateAvTest('Av_Test.Udp_Ok'),
			TcpPending: this.translateAvTest('Av_Test.Tcp_Pending'),
			TcpOk: this.translateAvTest('Av_Test.Tcp_Ok'),
			HttpPortsPending: this.translateAvTest('Av_Test.Http_Ports_Pending'),
			HttpPortsOk: this.translateAvTest('Av_Test.Http_Ports_Ok'),
			HttpPortsFail: this.translateAvTest('Av_Test.Http_Ports_Fail'),
			SpeedPrefix: this.translateAvTest('Av_Test.Speed_Prefix'),
			SpeedSuffixLow: this.translateAvTest('Av_Test.Speed_Suffix_Low'),
			SpeedSuffixTooLow: this.translateAvTest('Av_Test.Speed_Suffix_Too_Low'),
			SpeedSuffixOk: this.translateAvTest('Av_Test.Speed_Suffix_Ok'),
			SpeedFail: this.translateAvTest('Av_Test.Speed_Fail'),
			SpeedKbps: this.translateAvTest('Av_Test.Speed_Kbps'),
			MicrophoneLabelPrefix: this.translateAvTest('Av_Test.Microphone_Label_Prefix'),
			CameraLabelPrefix: this.translateAvTest('Av_Test.Camera_Label_Prefix'),
			NoMicrophone: this.translateAvTest('Av_Test.No_Microphone'),
			NoCamera: this.translateAvTest('Av_Test.No_Camera'),
			AV3: this.translateAvTest('Av_Test.Check_Audio_Video'),
			AV4: this.translateAvTest('Av_Test.Info_Audio'),
			AV5: this.translateAvTest('Av_Test.AV5'),
			AV6: this.translateAvTest('Av_Test.AV6'),
			AV7: this.translateAvTest('Av_Test.AV7'),
			AV8: this.translateAvTest('Av_Test.AV8'),
			AV10: this.translateAvTest('Av_Test.AV10'),
			AV11: this.translateAvTest('Av_Test.AV11'),
			AV12: this.translateAvTest('Av_Test.AV12'),
			PopupText1: this.translateAvTest('Av_Test.Browser_Not_Allowed'),
			PopupText2: this.translateAvTest('Av_Test.Popup_Text_2'),
			NotAllowed: this.translateAvTest('Av_Test.Not_Allowed'),
			NotReadable: this.translateAvTest('Av_Test.Not_Readable'),
		};
	}

	private translateAvTest(key: string) {
		return this.angularFilterHelperService.translateUnauthenticated(key);
	}
	
}
